import { useContext } from 'react'

import { Body1, Body2, Help, Masonry, Section, Stack, Switch } from '@collaborate-health/uikit'

import { UserNotificationSettingsContext } from '../../contexts'

import NotificationSettingsSkeleton from './NotificationSettingsSkeleton'

const NotificationSettings = () => {
  const { settingsInProcessing, notificationsCategories, isLoading, isError, isFetching, onNotificationSettingChange } =
    useContext(UserNotificationSettingsContext)

  if (isLoading) {
    return <NotificationSettingsSkeleton />
  }

  if (isError) {
    return <Body1 sx={{ textAlign: 'center', width: '100%' }}>Error loading notification settings</Body1>
  }

  return (
    <Masonry columns={2} spacing={2}>
      {notificationsCategories.map((category) => (
        <Section key={category.name} title={category.name}>
          <Stack spacing={2.5}>
            {category.notificationSettings.map((notificationSetting) => (
              <Stack key={notificationSetting.name} direction='row' justifyContent='space-between'>
                <Stack direction='row' gap={2.5}>
                  <Body2 mr={1}>{notificationSetting.name}</Body2>
                  {notificationSetting.description && <Help text={notificationSetting.description} />}
                </Stack>
                <Switch
                  disabled={settingsInProcessing.includes(notificationSetting.type!) || isFetching}
                  checked={notificationSetting.isEnabled}
                  onChange={(_event, checked) => onNotificationSettingChange(notificationSetting.type!, checked)}
                  size='large'
                />
              </Stack>
            ))}
          </Stack>
        </Section>
      ))}
    </Masonry>
  )
}

export default NotificationSettings

